import { render } from "./ChaptersAccordion.vue?vue&type=template&id=05ff2d12&scoped=true"
import script from "./ChaptersAccordion.vue?vue&type=script&lang=js"
export * from "./ChaptersAccordion.vue?vue&type=script&lang=js"

import "./ChaptersAccordion.vue?vue&type=style&index=0&id=05ff2d12&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05ff2d12"]])

export default __exports__